import React, {useEffect, useRef, useState} from "react";
import {prefersReducedMotion, hasIntersectionObserver} from "./motion";

// Apparition douce d'un contenu quand il entre à l'écran (« fade » ou « slide »). Le contenu est toujours dans le DOM ;
// il n'est masqué que si l'animation est possible (IntersectionObserver présent, mouvement non réduit). Sinon : visible
// tout de suite, sans mouvement.
export default function Reveal({animation = "none", children}) {
    const ref = useRef(null);
    const animated = animation !== "none" && hasIntersectionObserver() && !prefersReducedMotion();
    const [shown, setShown] = useState(!animated);

    useEffect(() => {
        if (!animated || shown || !ref.current) return undefined;
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                setShown(true);
                observer.disconnect();
            }
        }, {threshold: 0.12});
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [animated, shown]);

    return (
        <div ref={ref} className={`reveal${animated ? (shown ? " reveal--in" : " reveal--pending") : ""}`} data-animation={animation}>
            {children}
        </div>
    );
}
